import React, { FC, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import SelectStep from "../SelectStep/SelectStep";
import TimeStep from "../TimeStep/TimeStep";

interface Props {
	stepNumber: number;
}

const PostFrequencyStep: FC<Props> = ({ stepNumber }) => {
	const { control, setValue, clearErrors } = useFormContext<BannerFormState>();

	const fields = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${0}.givenAnswer`
	});

	// -1 is the value used for a one-off post. We use the value
	// from Day one only for a one-off.
	const DisableDayOne = String(fields) === "";
	const DisableDayTwo =
		String(fields) === "" || String(fields) === "-1" || String(fields) === "1";
	const DisableDayThree =
		String(fields) === "" ||
		String(fields) === "1" ||
		String(fields) === "-1" ||
		String(fields) === "2";

	useEffect(() => {
		if (DisableDayOne) {
			setValue(`steps.${stepNumber - 1}.fields.${1}.givenAnswer`, "");
			clearErrors([`steps.${stepNumber - 1}.fields.${1}.givenAnswer`]);
		}

		if (DisableDayTwo) {
			setValue(`steps.${stepNumber - 1}.fields.${2}.givenAnswer`, "");
			clearErrors([`steps.${stepNumber - 1}.fields.${2}.givenAnswer`]);
		}

		if (DisableDayThree) {
			setValue(`steps.${stepNumber - 1}.fields.${3}.givenAnswer`, "");
			clearErrors([`steps.${stepNumber - 1}.fields.${3}.givenAnswer`]);
		}
	}, [fields]);

	return (
		<div className="flex items-center gap-4 my-4">
			<div className="min-w-[190px]">
				<SelectStep stepNumber={stepNumber} order={1} />
			</div>

			<TimeStep stepNumber={stepNumber} isDisabled={DisableDayOne} order={2} />
			<TimeStep stepNumber={stepNumber} isDisabled={DisableDayTwo} order={3} />
			<TimeStep
				stepNumber={stepNumber}
				isDisabled={DisableDayThree}
				order={4}
			/>
		</div>
	);
};

export default PostFrequencyStep;
